import api from './client';
let entity = 'activities';


// GET /api/activities
export const getAll = async () => {
  const { data } = await api.get(`/${entity}`);
  return data;
};